// extracted by mini-css-extract-plugin
module.exports = {"requestsContainer":"UserCompletedRequests_requestsContainer__2g774","noRequests":"UserCompletedRequests_noRequests__2AScX"};